<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<div *ngIf="!loading && group" class="space-y-6">

  <!-- ──── SEÇÃO: DADOS DO GRUPO ──── -->
  <div class="bg-white rounded-lg border border-gray-200 p-6">
    <h2 class="text-lg font-semibold text-westetics-neutral-950 mb-4">Dados do Grupo</h2>
    <form [formGroup]="groupForm" (ngSubmit)="saveName()" class="flex flex-col sm:flex-row items-start sm:items-end gap-4">
      <div class="flex-1 w-full">
        <label for="groupName" class="block text-sm font-medium text-westetics-neutral-700 mb-1">Nome do Grupo</label>
        <input
          id="groupName"
          type="text"
          formControlName="name"
          class="w-full px-3 py-2 border border-westetics-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-westetics-purple-400 focus:border-westetics-purple-400"
          placeholder="Nome do grupo"
        />
        <p *ngIf="groupForm.get('name')?.touched && groupForm.get('name')?.hasError('required')"
           class="text-xs text-red-500 mt-1">
          O nome é obrigatório.
        </p>
        <p *ngIf="groupForm.get('name')?.touched && groupForm.get('name')?.hasError('minlength')"
           class="text-xs text-red-500 mt-1">
          O nome deve ter pelo menos 2 caracteres.
        </p>
      </div>
      <button
        type="submit"
        [disabled]="saving || groupForm.invalid || groupForm.pristine"
        class="px-5 py-2 text-sm bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap">
        {{ saving ? 'Salvando...' : 'Salvar Nome' }}
      </button>
    </form>
  </div>

  <!-- ──── SEÇÃO: COMPARTILHAMENTO ──── -->
  <div class="bg-white rounded-lg border border-gray-200 p-6">
    <h2 class="text-lg font-semibold text-westetics-neutral-950 mb-1">Compartilhamento de Dados</h2>
    <p class="text-sm text-westetics-neutral-500 mb-4">
      Defina quais tipos de dados são compartilhados entre as clínicas deste grupo.
    </p>

    <div class="space-y-3">
      <label class="flex items-center gap-3 cursor-pointer">
        <input type="checkbox" [(ngModel)]="sharePatients"
               class="w-4 h-4 text-westetics-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-westetics-purple-500" />
        <div>
          <span class="text-sm font-medium text-westetics-neutral-900">Pacientes</span>
          <p class="text-xs text-westetics-neutral-500">Todas as clínicas do grupo poderão visualizar e atender os pacientes de outras clínicas.</p>
        </div>
      </label>

      <label class="flex items-center gap-3 cursor-pointer">
        <input type="checkbox" [(ngModel)]="shareProcedures"
               class="w-4 h-4 text-westetics-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-westetics-purple-500" />
        <div>
          <span class="text-sm font-medium text-westetics-neutral-900">Procedimentos</span>
          <p class="text-xs text-westetics-neutral-500">Tabela de procedimentos e valores será unificada entre as clínicas do grupo.</p>
        </div>
      </label>

      <label class="flex items-center gap-3 cursor-pointer">
        <input type="checkbox" [(ngModel)]="shareProviders"
               class="w-4 h-4 text-westetics-purple-600 bg-gray-100 border-gray-300 rounded focus:ring-westetics-purple-500" />
        <div>
          <span class="text-sm font-medium text-westetics-neutral-900">Prestadores</span>
          <p class="text-xs text-westetics-neutral-500">Prestadores de serviço serão compartilhados entre as clínicas do grupo.</p>
        </div>
      </label>
    </div>

    <div class="mt-4 flex justify-end">
      <button (click)="saveSharing()"
              [disabled]="savingSharing"
              class="px-5 py-2 text-sm bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        {{ savingSharing ? 'Salvando...' : 'Salvar Compartilhamento' }}
      </button>
    </div>
  </div>

  <!-- ──── SEÇÃO: CLÍNICAS DO GRUPO ──── -->
  <div class="bg-white rounded-lg border border-gray-200 p-6">
    <div class="flex items-center justify-between mb-4">
      <h2 class="text-lg font-semibold text-westetics-neutral-950">
        Clínicas do Grupo
        <span class="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-westetics-purple-100 text-westetics-purple-800">
          {{ group.clinics?.length ?? 0 }}
        </span>
      </h2>
      <div class="flex items-center gap-2">
        <button
          (click)="openDeleteModal()"
          class="px-4 py-2 text-sm border border-red-400 text-red-500 hover:bg-red-50 rounded-lg transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
          </svg>
          Excluir Grupo
        </button>
        <button
          (click)="openAssignModal()"
          class="px-4 py-2 text-sm bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg transition-colors flex items-center gap-2">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
          </svg>
          Adicionar Clínica
        </button>
      </div>
    </div>

    <!-- Tabela de clínicas (Desktop) -->
    <div class="hidden md:block overflow-x-auto" *ngIf="group.clinics && group.clinics.length > 0">
      <table class="w-full text-sm text-left text-gray-500">
        <thead class="text-xs text-white bg-westetics-purple-300">
          <tr>
            <th class="px-5 py-2 font-medium text-sm">Razão Social</th>
            <th class="px-5 py-2 font-medium text-sm">CNPJ</th>
            <th class="px-5 py-2 font-medium text-sm">Cidade</th>
            <th class="px-5 py-2 font-medium text-sm">Estado</th>
            <th class="px-5 py-2 font-medium text-sm">Status</th>
            <th class="px-5 py-2 font-medium text-sm text-right">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let clinic of group.clinics" class="border-b hover:bg-gray-50">
            <td class="p-4 text-sm text-westetics-neutral-950 font-medium">
              {{ clinic.corporate_name }}
            </td>
            <td class="p-4 text-sm text-westetics-neutral-700">
              {{ clinic.cnpj }}
            </td>
            <td class="p-4 text-sm text-westetics-neutral-700">
              {{ clinic.city || '—' }}
            </td>
            <td class="p-4 text-sm text-westetics-neutral-700">
              {{ clinic.state || '—' }}
            </td>
            <td class="p-4 text-sm">
              <span [ngClass]="{
                'bg-green-100 text-green-800': !clinic.is_blocked,
                'bg-red-100 text-red-800': clinic.is_blocked
              }" class="px-2 py-0.5 rounded-full text-xs font-medium">
                {{ clinic.is_blocked ? 'Bloqueado' : 'Ativo' }}
              </span>
            </td>
            <td class="p-4 text-sm text-right">
              <div class="flex items-center justify-end gap-2">
                <button (click)="openRemoveModal(clinic)"
                        class="text-red-500 hover:text-red-700 transition-colors p-1"
                        title="Remover do grupo">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Cards de clínicas (Mobile) -->
    <div class="md:hidden space-y-3" *ngIf="group.clinics && group.clinics.length > 0">
      <div *ngFor="let clinic of group.clinics"
           class="bg-white rounded-lg border border-gray-200 p-4">
        <div class="flex justify-between items-start mb-2">
          <div class="min-w-0 flex-1">
            <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ clinic.corporate_name }}</h3>
            <p class="text-xs text-westetics-neutral-600">{{ clinic.cnpj }}</p>
          </div>
          <span [ngClass]="{
            'bg-green-100 text-green-800': !clinic.is_blocked,
            'bg-red-100 text-red-800': clinic.is_blocked
          }" class="px-2 py-0.5 rounded-full text-xs font-medium ml-2">
            {{ clinic.is_blocked ? 'Bloqueado' : 'Ativo' }}
          </span>
        </div>
        <p class="text-xs text-westetics-neutral-500 mb-3">
          {{ clinic.city || '—' }}, {{ clinic.state || '—' }}
        </p>
        <div class="flex items-center gap-2">
          <button (click)="openRemoveModal(clinic)"
                  class="text-xs text-red-500 border border-red-300 rounded-md px-3 py-1 hover:bg-red-50 transition-colors">
            Remover
          </button>
        </div>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!group.clinics || group.clinics.length === 0" class="text-center py-10">
      <svg class="w-12 h-12 text-westetics-neutral-300 mx-auto mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
              d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
      </svg>
      <p class="text-sm text-westetics-neutral-500">Nenhuma clínica vinculada a este grupo.</p>
      <button (click)="openAssignModal()"
              class="mt-3 text-sm text-westetics-purple-800 hover:underline">
        Adicionar a primeira clínica
      </button>
    </div>
  </div>


</div>

<!-- ──── MODAL: ADICIONAR CLÍNICA ──── -->
<div *ngIf="showAssignModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-xl p-6 max-w-lg mx-4 w-full max-h-[80vh] flex flex-col">
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-lg font-semibold text-westetics-neutral-950">Adicionar Clínica ao Grupo</h3>
      <button (click)="closeAssignModal()" class="text-westetics-neutral-400 hover:text-westetics-neutral-600">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
    </div>

    <!-- Busca -->
    <input
      type="text"
      [(ngModel)]="assignSearchTerm"
      (ngModelChange)="filterAvailableClinics()"
      placeholder="Buscar por nome ou CNPJ..."
      class="w-full px-3 py-2 border border-westetics-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-westetics-purple-400 mb-3"
    />

    <!-- Loading -->
    <div *ngIf="loadingClinics" class="text-center py-8 text-sm text-westetics-neutral-500">
      Carregando clínicas...
    </div>

    <!-- Loading ao adicionar -->
    <div *ngIf="assigningClinic" class="text-center py-8 text-sm text-westetics-neutral-500">
      <svg class="animate-spin h-5 w-5 mx-auto mb-2 text-westetics-purple-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      Adicionando clínica...
    </div>

    <!-- Lista de clínicas disponíveis -->
    <div *ngIf="!loadingClinics && !assigningClinic" class="overflow-y-auto flex-1 space-y-1">
      <div *ngFor="let clinic of filteredAvailableClinics"
           (click)="assignClinic(clinic)"
           class="flex items-center justify-between px-3 py-2.5 rounded-lg cursor-pointer hover:bg-westetics-purple-50 border border-transparent hover:border-westetics-purple-200 transition-all">
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium text-westetics-neutral-950 truncate">{{ clinic.corporate_name }}</p>
          <p class="text-xs text-westetics-neutral-500">{{ clinic.cnpj }}</p>
        </div>
        <span *ngIf="clinic.group_id && clinic.group_id !== groupId"
              class="text-[10px] text-amber-600 bg-amber-50 px-2 py-0.5 rounded-full ml-2 whitespace-nowrap">
          Em outro grupo
        </span>
        <svg class="w-4 h-4 text-westetics-purple-400 ml-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
        </svg>
      </div>

      <div *ngIf="filteredAvailableClinics.length === 0" class="text-center py-6 text-sm text-westetics-neutral-500">
        Nenhuma clínica disponível encontrada.
      </div>
    </div>
  </div>
</div>

<!-- ──── MODAL: CONFIRMAR REMOÇÃO ──── -->
<div *ngIf="showRemoveModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-xl p-6 max-w-md mx-4 w-full">
    <h3 class="text-lg font-semibold text-westetics-neutral-950 mb-2">Remover Clínica</h3>
    <p class="text-sm text-westetics-neutral-600 mb-6">
      Tem certeza que deseja remover <strong>{{ clinicToRemove?.corporate_name }}</strong> do grupo
      <strong>{{ group?.name }}</strong>? A clínica não será excluída.
    </p>
    <div class="flex justify-end gap-3">
      <button (click)="closeRemoveModal()"
              [disabled]="removingClinic"
              class="px-4 py-2 text-sm border border-westetics-gray-200 rounded-lg hover:bg-westetics-neutral-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
        Cancelar
      </button>
      <button (click)="confirmRemoveClinic()"
              [disabled]="removingClinic"
              class="px-4 py-2 text-sm bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2">
        <svg *ngIf="removingClinic" class="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
        {{ removingClinic ? 'Removendo...' : 'Remover' }}
      </button>
    </div>
  </div>
</div>

<!-- ──── MODAL: CONFIRMAR EXCLUSÃO DO GRUPO ──── -->
<div *ngIf="showDeleteModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="bg-white rounded-lg shadow-xl p-6 max-w-md mx-4 w-full">
    <h3 class="text-lg font-semibold text-westetics-neutral-950 mb-2">Excluir Grupo</h3>
    <p class="text-sm text-westetics-neutral-600 mb-1">
      Tem certeza que deseja excluir o grupo <strong>{{ group?.name }}</strong>?
    </p>
    <p class="text-xs text-westetics-neutral-500 mb-6">
      As {{ group?.clinics?.length ?? 0 }} clínica(s) vinculada(s) serão desvinculadas automaticamente.
    </p>
    <div class="flex justify-end gap-3">
      <button (click)="closeDeleteGroupModal()"
              class="px-4 py-2 text-sm border border-westetics-gray-200 rounded-lg hover:bg-westetics-neutral-50 transition-colors">
        Cancelar
      </button>
      <button (click)="confirmDeleteGroup()"
              class="px-4 py-2 text-sm bg-red-500 hover:bg-red-600 text-white rounded-lg transition-colors">
        Excluir Grupo
      </button>
    </div>
  </div>
</div>
